<template>
<div>
   <span class="spinner-border spinner-border-md text-primary" role="status"
         aria-hidden="true"></span>
  <span :class="textSize">Loading please wait...</span>
</div>
</template>

<script>
import data_loading from '@/assets/data_loading.webp';

export default {
  name: "AppLoading",

  /** props **/
  props: {
    textSize: {
      type: String,
    },

    loading: {
      type: Boolean,
      default: false,
    },

  },

  data() {
    return {
      dataLoading: data_loading
    }
  }

}
</script>

<style scoped>

</style>
